import { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';

const Portal = ({ children }) => {
  const ref = useRef(null);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    ref.current = document.getElementById('portal-root');
    setMounted(true);
  }, [ref.current]);

  return mounted ? createPortal(children, ref.current) : null;
};

export default Portal;
